import React from "react";

function DoorConflict() {
    return (
        <div>
            <h2>Communication & Conflict Management</h2>
            <p>
                Effective communication and conflict resolution are vital skills for Door Supervisors. This module focuses on how to prevent, de-escalate, and manage conflict while maintaining professionalism and safety.
            </p>

            <h3>Understanding Conflict</h3>
            <ul>
                <li>Conflict can arise from misunderstandings, intoxication, frustration, or aggression</li>
                <li>Recognizing early warning signs helps prevent escalation</li>
                <li>Remain calm, observant, and non-confrontational</li>
            </ul>

            <h3>Communication Techniques</h3>
            <ul>
                <li>Use open body language and maintain appropriate eye contact</li>
                <li>Speak clearly, calmly, and respectfully</li>
                <li>Listen actively and show empathy</li>
                <li>Avoid provocative language or gestures</li>
            </ul>

            <h3>De-escalation Strategies</h3>
            <ul>
                <li>Stay calm and avoid reacting emotionally</li>
                <li>Offer choices and solutions to reduce tension</li>
                <li>Use non-threatening language and tone</li>
                <li>Maintain a safe distance and be aware of exits</li>
            </ul>

            <h3>Managing Aggression</h3>
            <ul>
                <li>Call for backup or emergency services if needed</li>
                <li>Use conflict resolution before considering physical intervention</li>
                <li>Document the incident accurately and promptly</li>
            </ul>

            <h3>Scenario Practice</h3>
            <p>
                <strong>Example:</strong> A customer is refused entry due to intoxication and becomes verbally aggressive. How do you respond?
            </p>
            <ul>
                <li>Stay calm and explain the reason clearly</li>
                <li>Offer alternatives (e.g., “Come back another night”)</li>
                <li>Avoid escalation and call for support if needed</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Conflict Management</a></li>
                <li><a href="https://www.suzylamplugh.org/" target="_blank" rel="noreferrer">Suzy Lamplugh Trust – Personal Safety</a></li>
                <li><a href="https://www.crisisprevention.com/" target="_blank" rel="noreferrer">Crisis Prevention Institute – De-escalation Tips</a></li>
            </ul>
        </div>
    );
}

export default DoorConflict;
